import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { SHARE_BUTTON_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const SHARE_BUTTON_PAGE_SEGMENT_LOAD: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: SHARE_BUTTON_SEGMENT_KEY,
});
